<agr-page-toolbar
  [pageTitle]="pageTitle$ | async"
  [buttonItems]="buttons"
  (buttonAction)="onButtonAction($event)"
  class="individual-production"
>
  <div class="wrapper--spacing-all">
    <div class="flex--justify-space-between">
      <app-production-picker
        (productionChanged)="onProductionChanged($event)"
      ></app-production-picker>
      <mat-slide-toggle
        [hideIcon]="true"
        (change)="showOnlyAttentionsChange($event)"
        [(ngModel)]="showOnlyAttentions"
        color="primary"
      >
        {{ 'dairyresults.individual-production.showOnlyAttentionsToggleLabel' | translate }}
      </mat-slide-toggle>
    </div>

    <mat-list role="list" class="container"> </mat-list>

    <agr-table data-test="cows-list__table" [config]="tableConfig">
      <ng-template #valueAttentionColumnTemplate let-row="row" let-column="column">
        <span
          class="spacing--margin-right spacing--padding-right"
          [ngClass]="setAttention(column.id, row)"
        >
          {{ row[column.id] | number: column.digitsInfo }}
        </span>
      </ng-template>
      <ng-template #cowDetailsTemplate let-row="row" let-column="column">
        <button mat-button (click)="openCowDetails(row)">
          {{ row[column.id] }}
        </button>
      </ng-template>
    </agr-table>
  </div>
</agr-page-toolbar>
